import { useTranslation } from 'react-i18next';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import { useMemo } from 'react';
import { ff_isPlacementStatusDisabled } from '../NextPlacementStatus/Helper';
import { placementStatusOptions } from '../NextPlacementStatus/StatusDefaults';

export const CreateCandidateContractXGridBtn = ({
  disableDueToStatus = false,
  onClick = undefined,
  currentPlacementStatus,
  statusChangeDecision,
  disabled = false,
}) => {
  const isEnabled = useMemo(() => {
    if (!currentPlacementStatus || !statusChangeDecision) return false;
    return !ff_isPlacementStatusDisabled(
      statusChangeDecision,
      placementStatusOptions.candidateContract,
      currentPlacementStatus,
    );
  }, [currentPlacementStatus, statusChangeDecision]);

  const { t } = useTranslation();

  return [
    {
      title: t('placement.profile.contract'),
      Icon: HistoryEduIcon,
      disabled: !isEnabled || disableDueToStatus || disabled,
      tooltipProps: {
        tooltipContent: !isEnabled
          ? t('placement.profile.clientConfirmation.featureDisabled')
          : disableDueToStatus
          ? t('placement.profile.clientConfirmation.disabledDueToPlacementStatus')
          : null,
        disabled: isEnabled && !disableDueToStatus,
      },
      onClick: event => {
        onClick?.(event);
      },
    },
  ];
};
